<div class="container-fluid">
	<div class="row flex-nowrap">

		<div id="menu-panel" class="col-auto d-none d-md-block">

			<div class="menu-header text-center">
				<i class="fa fa-4x fa-desktop page-icon"></i>
			</div>

			<div>
				<div class="text-center">LISTA</div>
				<button id="filter-btn" class="btn btn-dark pl-3 pr-3 mb-2" onclick="Anvil.page.searchModal()"><i class="fa fa-lg mb-2 fa-search"></i><br />Szűrő</button><br />
				<button class="btn btn-primary pl-3 pr-3" onclick="Anvil.page.refresh()"><i class="fa fa-lg mb-2 fa-sync-alt"></i><br />Frissítés</button>
				<!--
				<hr />
				<div class="text-center">ADATOK</div>
				<div class="btn-group-vertical">
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-import"></i><br />Importálás</button>
					<button class="btn btn-success pl-3 pr-3"><i class="fa fa-lg mb-2 fa-file-export"></i><br />Exportálás</button>
				</div>
				-->
			</div>
		</div>

		<div class="col list-panel">

			<div class="row">
				<div class="col">

					<div class="page-header">

						<div class="float-end pt-4">
							<div class="row g-2">
								<div class="col-auto d-none d-lg-block" style="width:160px;">
									<%- include('/ui/form', {
										params: [ 'search_1', search ],
										fields: [
											{
												type: 'select',
												inline: true,
												name: 'archive',
												title: 'Státusz',
												params: {
													maxItems: 1,
													options: [
														{ value: 0, label: 'Élő', icon: 'clipboard-check', color: 'text-success' },
														{ value: 1, label: 'Archív', icon: 'archive', color: 'text-warning' }
													],
													valueField: 'value',
													labelField: 'label',
													render: {
														item: (item, esc) => `<div><i class="fa fa-fw fa-${item.icon} me-2 ${item.color}"></i>${esc(item.label)}</div>`,
														option: (item, esc) => `<div class="option"><i class="fa fa-fw fa-${item.icon} me-2 ${item.color}"></i>${esc(item.label)}</div>`
													},
													placeholder: '[ minden státusz ]'
												},
												append: '<button class="btn btn-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.archive = null;"><i class="fa fa-fw fa-times"></i></button>',
												update: (value) => {
													Anvil.page.quickSearch()
												}
											}
										]
									}) %>
								</div>
								<div class="col d-none d-lg-block" style="width:380px;">
									<%- include('/ui/form', {
										params: [ 'search_2', search ],
										fields: [
											{
												type: 'select',
												inline: true,
												name: 'company_group_id',
												title: 'Cég csoport',
												params: {
													maxItems: 1,
													options: [ { id: -1, name: '[ csoporton kívüli ]' }, ...company_groups.data ],
													valueField: 'id',
													labelField: 'name',
													searchField: [ 'name' ],
													render: {
														item: (item, esc) => `<div>${esc(item.name)}</div>`,
														option: (item, esc) => `<div class="option">${esc(item.name)}</div>`
													},
													placeholder: '[ minden cégcsoport ]'
												},
												unset_value: null,
												prepend: '<span class="input-group-text"><i class="fa fa-city"></i></span>',
												append: '<button class="btn text-dark" style="border-color:var(--bs-border-color);" onclick="Anvil.page.search.company_group_id = null;"><i class="fa fa-fw fa-times"></i></button>',
												update: (value) => {
													Anvil.page.quickSearch()
												}
											}
										]
									}) %>
								</div>
								<div class="col-auto" style="width:300px; max-width:50vw;">
									<div class="input-group">
										<input type="text" class="form-control" id="text-search" placeholder="Keresés..." oninput="Anvil.page.quickSearch()" />
										<span class="input-group-text"><i class="fa fa-search"></i></span>
									</div>
								</div>
							</div>
						</div>

						<h2>Terminálok</h2>
						<ol class="breadcrumb">
							<li class="breadcrumb-item"><a href="/home"><i class="fa fa-home"></i></a></li>
							<li class="breadcrumb-item">Termék menedzsment</li>
							<li class="breadcrumb-item">c-Order</li>
							<li class="breadcrumb-item active">Terminálok</li>
						</ol>
					</div>

					<%- include('/ui/grid', {
						name: 'terminal',
						params: {
							row_height: 48,
							row_class: (row) => {
								if (row.sandbox) return 'bg-body-secondary text-dim'
								return ''
							},
							render_footer (list, map) {
								let selection_total = 0
								let total = 0
								for (let terminal of list.data) {
									if (terminal.archive == 0) {
										total += terminal.total_debit
										total -= terminal.total_dividend
									}
								}
								for (let terminal of map) {
									selection_total += terminal.total_debit
									selection_total -= terminal.total_dividend
								}
								return `Szűrt lista havidíj: <strong class="m-0 p-0" style="color:greenyellow;">${Anvil.numeral(selection_total).format('0,0')} Ft</strong><span class="mx-2">|</span>Összes élő havidíj: <strong class="m-0 p-0" style="color:goldenrod;">${Anvil.numeral(total).format('0,0')} Ft</strong>`
							},
							filters: [ t => t.archive == 0 ],
							columns: [
								{
									title: 'Menü',
									field: 'id',
									value: (v, row) => {
										if (row.company_group_name !== null) {
											return row.company_group_name
										} else {
											return ''
										}
									},
									type: {
										render (value, row, options) {
											return `
												<div class="btn-group">
													<div class="dropdown">
														<button class="btn btn-dark text-light p-2" data-bs-toggle="dropdown" style="border-radius:var(--bs-btn-border-radius) 0 0 var(--bs-btn-border-radius);"><i class="fa fa-fw fa-bars mx-1"></i></button>
														<ul class="dropdown-menu" style="min-width:180px; box-shadow:0 2px 5px rgba(0, 0, 0, 0.1);">
															<li><a class="dropdown-item p-2" href="/c_order/error_log/list?machine_id=${row.machine_id}"><i class="fa fa-fw fa-wrench me-2"></i>Hibanapló ${row.error_count ? `<span class="float-end">(${row.error_count})</span>` : ''}</i></a></li>
															<li><a class="dropdown-item p-2" href="/c_order/error_log/ntak_error_list?db_name=${row.company_db_name}"><i class="fa fa-fw fa-exclamation-triangle me-2"></i>NTAK Hibanapló ${row.ntak_errors ? `<span class="float-end">(${row.ntak_errors})</span>` : ''}</a></li>
															<li><a class="dropdown-item p-2" href="/c_order/storage/calendar?db_name=${row.company_db_name}&storage_id=${row.storage_id}"><i class="fa fa-fw fa-calendar me-2"></i>NTAK Monitor</a></li>
															<li><a class="dropdown-item p-2" href="https://dbserver01.webdisk.hu:8010/phpmyadmin/index.php?route=/database/structure&db=c1_cstore_${row.company_db_name}" target="_blank"><i class="fa fa-fw fa-server me-2"></i>Adatbázis</a></li>
															<li><button class="dropdown-item p-2 ${row.company_db_name !== null ? '' : 'disabled text-dim'}" onclick="Anvil.page.sign_in_to_cloud('${row.company_db_name}')"><i class="fa fa-fw fa-cloud me-2"></i>Felhő belépés</button></li>
														</ul>
													</div>
													<button class="btn btn-dark p-2 ${row.anydesk_id ? 'text-warning' : 'disabled text-dim'}" onclick="Anvil.page.connect_with_anydesk('${row.machine_id}')"><i class="fa fa-fw fa-headset mx-1"></i></button>
												</div>
											`
										}
									},
									options: {
										class: 'text-center pb-0 overflow-visible'
									},
									width: 100
								},
								{
									title: 'Cég',
									field: 'company_name',
									value: (v, row) => `${row.company_name} ${row.company_tax_number}`,
									type: {
										render (value, row, options) {
											if (row.company_id === null) return '&nbsp;<br /><small>&nbsp;</small>'
											return `
												${row.company_name}<br />
												<small class="text-dim">${row.company_tax_number}</small>`
										}
									},
									options: {
										cutoff: 60
									},
									width: 180
								},
								{
									title: 'Adatbázis',
									field: 'company_db_name',
									type: 'string',
									options: {
										cutoff: 60
									},
									width: 80
								},
								{
									title: 'Csoport',
									field: 'company_group_id',
									type: {
										render (value, row, options) {
											if (value === null) return '&nbsp;<br /><small>&nbsp;</small>'
											return `<img src="assets/groups/${value}.png" />`
										}
									},
									options: {
										class: 'text-center'
									},
									width: 70
								},
								{
									title: 'Telephely',
									field: 'site_name',
									value: (v, row) => `${row.site_location_name} ${row.site_public_name} ${row.site_name} ${row.site_area_code || ''} ${row.site_city || ''} ${row.site_address || ''}`,
									type: {
										render (value, row, options) {
											return `
												<div class="list-db-id">
													<button class="btn btn-sm btn-dark px-2 py-0" onclick="Anvil.page.openSite('${row.company_db_id}', '${row.site_id}')"><i class="fa fa-sm fa-fw fa-${Anvil.models.c_order.Site.Types.find(t => t.value == row.site_type).icon}"></i></button><br />
													${row.site_geo_coords ? '<small class="text-dim"><i class="fa fa-map-marker-alt"></i></small>' : '<small class="text-warning"><i class="fa fa-map-marker-alt" style="transform:rotate(30deg);"></i></small>'}
												</div>
												${row.site_location_name ? `<span style="color:yellowgreen;">${row.site_location_name}</span> &bullet; ` : ''} ${row.site_public_name ? row.site_public_name : row.site_name}<br />
												<small class="text-dim">${row.site_city ? `<span class="text-gold">${row.site_city}</span>` : ''}` + (row.site_address ? `, ${row.site_address}` : '') + `</small>`
										}
									},
									options: {
										cutoff: 60
									},
									width: 260
								},
								{
									title: 'Név / Raktár',
									field: 'storage_name',
									value: (v, row) => {
										return `${row.device_info.hostname} ${row.storage_name}`
									},
									type: {
										render (value, row, options) {
											const localdb = (row.config && ['', 'localhost', '127.0.0.1'].includes(row.config.database.db_host))
											const landb = (row.config && !['', 'localhost', '127.0.0.1'].includes(row.config.database.db_host))
											const online = Anvil.moment(row.now).subtract(2, 'minutes').isBefore(Anvil.moment(row.last_report_dt))
											const warn = (row.remote_settings && row.remote_settings.warning_mode && row.remote_settings.warning_mode != 'none')
											const dt = Anvil.moment(row.recent_start)
											const color = (dt.isBefore(Anvil.moment().subtract(1, 'month'))) ? 'text-danger' :
														(dt.isBefore(Anvil.moment().subtract(1, 'week'))) ? 'text-warning' : 'text-blue'
											return `<div class="list-db-id">
														${localdb ? `<i class="fa fa-server ${color}"></i>` : landb ? `<i class="fa fa-network-wired ${color}"></i>` : ''}
														<i class="fa fa-desktop ${color}"></i><br /><small class="text-dim">${row.storage_id}</small>
													</div>
													${warn ? `<div class="float-end ms-2"><span class="material-icons-outlined text-danger">warning</span></div>` : ''}
													${online ? `<div class="float-end ms-2"><span class="material-icons-outlined text-success">router</span></div>` : ''}
													<strong class="${color}">${row.device_info.hostname}</strong><br />
													<small class="text-dim">${row.storage_name}</small>`
										}
									},
									options: {
										cutoff: 40
									},
									width: 270
								},
								{
									title: 'NTAK',
									field: 'settings',
									value: (v, row) => {
										if (row.ntak_cert !== null) {
											return row.ntak_cert.regnumber
										} else {
											return ''
										}
									},
									type: {
										render (value, row, options) {
											var queue = (row.ntak_queue) ? `<span class="float-end"><span class="${(row.ntak_queue.SEND > 25) ? 'text-warning text-strong' : 'text-dim'}">S:${row.ntak_queue.SEND}</span> / <span class="${(row.ntak_queue.PENDING > 50) ? 'text-warning text-strong' : 'text-dim'}">P:${row.ntak_queue.PENDING}</span></span>` : ''
											var top = '<div>&nbsp;</div>'
											var bottom = ''

											var has_cert = row.ntak_cert !== null
											var cert_needed = false

											if (row.settings !== null) {
												if (row.settings.ntak_enabled == 'on') {
													top = `${queue}<div class="text-success"><i class="fa fa-fw fa-university"></i> Éles</div>`
													cert_needed = true
												} else if (row.settings.ntak_enabled == 'prepare') {
													top = `${queue}<div class="${has_cert ? 'text-danger' : 'text-secondary'}"><i class="fa fa-fw fa-cog fa-spin"></i> Készül</div>`
												}
											}
											if (row.ntak_cert !== null) {
												if (row.ntak_cert.sandbox == '1') {
													bottom = `<div class="text-info" title="${Anvil.moment(row.validto_time).format('YYYY. MM. DD. HH:mm')}"><i class="fa fa-fw fa-certificate"></i> ${row.ntak_cert.regnumber} <strong>Teszt</strong></div>`
												} else {
													bottom = `<div class="text-success" title="${Anvil.moment(row.validto_time).format('YYYY. MM. DD. HH:mm')}"><i class="fa fa-fw fa-certificate"></i> ${row.ntak_cert.regnumber}</div>`
												}
											} else {
												bottom = `<div class="${cert_needed ? 'text-danger' : 'text-secondary'}"><i class="fa fa-fw fa-certificate"></i> Nincs</div>`
											}
											return `${top}${bottom}`
										}
									},
									width: 160
								},
								{
									title: 'Pénztárgép',
									field: 'default_cashreg_ap',
									type: {
										render (value, row, options) {
											if (row.default_cashreg_ap === null) return ''
											return `<div class="list-db-id"><i class="fa fa-fw fa-cash-register text-primary"></i></div><strong>${row.default_cashreg_ap}</strong></span><br />
													${row.aee_last_inspection_d ? Anvil.moment(row.aee_last_inspection_d).add(1, 'year').format('YYYY.MM.DD') : ''}`

											// ${('msacsrv' in row.device_info) ? `<small class="text-dim">exe:${row.device_info.msacsrv.exe}; dll:${row.device_info.msacsrv.dll}</small>` : ''}`
										}
									},
									options: {
										cutoff: 40
									},
									width: 180
								},
								{
									title: 'Verzió',
									field: 'version',
									type: {
										render (value, row, options) {

											const channel = {
												'stable': `<span class="text-${Anvil.models.c_order.Versions.colors['stable']}"><i class="fa fa-angle-right"></i> Stabil</span>`,
												'beta': `<span class="text-${Anvil.models.c_order.Versions.colors['beta']}"><i class="fa fa-angle-double-right"></i> Béta</span>`,
												'alpha': `<span class="text-${Anvil.models.c_order.Versions.colors['alpha']}"><i class="fa fa-bug"></i> Alpha</span>`
											}[row.update_channel] || '<span class="text-dim"><i class="fas fa-hand-paper fa-flip-horizontal"></i> Ne frissüljön</span>'

											return `
												<strong class="text-${Anvil.models.c_order.Versions.colors[Anvil.page.versions.verstate(value)]}">${value}</strong><br />
												<small class="text-secondary">${channel}</small>`
										}
									},
									options: {
										cutoff: 40,
										class: 'text-end'
									},
									width: 110
								},
								{
									title: 'Havidíj',
									field: 'total_debit',
									type: {
										render (value, row, options) {
											return `<strong style="color:goldenrod;">${Anvil.numeral(value).format('0,0')}</strong>` + (row.partner_dividend > 0 ? `<br /><strong style="color:peru;">-${Anvil.numeral(row.partner_dividend).format('0,0')}</strong>` : '')
										}
									},
									options: {
										class: 'text-end'
									},
									width: 80
								},
								/*
								{
									title: 'Szerviz partner',
									field: 'service_partner_name',
									value: (v, row) => `${row.service_partner_name} ${row.service_partner_tax_number}`,
									type: {
										render (value, row, options) {
											if (row.service_partner_id === null) return '&nbsp;<br /><small>&nbsp;</small>'
											return `${row.service_partner_name}<br /><small class="text-dim">${row.service_partner_tax_number}</small>`
										}
									},
									options: {
										cutoff: 60
									},
									width: 170
								},
								*/
								{
									title: 'Első indítás',
									field: 'first_start',
									type: {
										render (value, row, options) {
											const dt = Anvil.moment(value)
											return `${dt.format('YYYY.MM.DD. HH:mm')}<br /><small class="text-secondary">${dt.fromNow()}</small>`
										}
									},
									width: 140
								},
								{
									title: 'Utolsó indítás',
									field: 'recent_start',
									type: {
										render (value, row, options) {
											const dt = Anvil.moment(value)
											if (dt.isBefore(Anvil.moment().subtract(1, 'month'))) {
												return `<span class="text-danger">${dt.format('YYYY.MM.DD. HH:mm')}</span><br /><small class="text-secondary">${dt.fromNow()}</small>`
											} else if (dt.isBefore(Anvil.moment().subtract(1, 'week'))) {
												return `<span class="text-warning">${dt.format('YYYY.MM.DD. HH:mm')}</span><br /><small class="text-secondary">${dt.fromNow()}</small>`
											} else {
												return `${dt.format('YYYY.MM.DD. HH:mm')}<br /><small class="text-secondary">${dt.fromNow()}</small>`
											}
										}
									},
									width: 140
								},
								{
									title: '101',
									field: 'settings',
									type: {
										render (value, row, options) {
											if (row.settings && row.settings.payment_methods && row.settings.payment_methods.find(x => x.id == 101)) {
												if (row.settings.payment_methods.find(x => x.id == 101).name_hu != 'Utalvány') {
													return `<div class="text-info"><i class="fa fa-fw fa-exclamation-triangle"></i></div>`
												} else {
													return `<div class="text-${row.settings && row.settings.payment_methods && row.settings.payment_methods.find(x => x.id == 101).enabled_for_ecr ? 'success' : 'danger'}"><i class="fa fa-fw fa-circle"></i></div>`
												}
											} else {
												return ''
											}
										}
									},
									options: {
										class: 'text-center'
									},
									width: 40
								}
							]
						},
						list: terminals
					}) %>
				</div>
			</div>

			<div class="py-3">
				<button onclick="history.back()" class="btn btn-dark"><i class="fa fa-angle-left me-2"></i>Vissza</button>
				<div class="float-end">
					<button class="btn btn-primary ml-2" onclick="Anvil.page.open()"><i class="fa fa-fw fa-edit"></i><span class="d-none d-md-inline ms-2">Megnyitás</span></button>
				</div>
			</div>

		</div>

	</div>
</div>

<script>
Object.assign(Anvil.page, {

	searchModal () {
		Anvil.modal('/c_order/terminal/page_list_search_modal', { search: Anvil.page.search })
	},

	quickSearch () {
		const filters = []

		if (Anvil.page.search.archive === '0' || Anvil.page.search.archive === '1') {
			filters.push(row => row.archive == parseInt(Anvil.page.search.archive))
		}

		if (Anvil.page.search.company_group_id) {
			if (Anvil.page.search.company_group_id == -1) {
				filters.push(row => row.company_group_id === null)
			} else {
				filters.push(row => row.company_group_id == Anvil.page.search.company_group_id)
			}
		}

		const expression = $('#text-search').val()

		Anvil.models.components.Grid.find('#terminal_grid').filter(expression, filters)
	},

	refresh () {
		Anvil.exec('c_order/terminal/action_refresh')
	},

	async connect_with_anydesk (machine_id) {

		// Find terminal
		const terminal = Anvil.page.terminals.getByMachineId(machine_id)
		if (terminal !== undefined) {
			// Request confirmation
			Anvil.confirm({
				title: 'Anydesk kapcsolat',
				message: `
					<p>Biztosan szeretnél csatlakozni a kiválasztott terminálhoz?</p>
					<table style="font-size:0.9em;">
						<tr>
							<td class="pe-3">Cég</td>
							<td><strong>${terminal.company_name}</strong></td>
						</tr>
						<tr>
							<td class="pe-3">Telephely</td>
							<td><strong>${terminal.site_name}</strong></td>
						</tr>
						<tr>
							<td class="pe-3" valign="top">Terminál</td>
							<td><strong>${terminal.device_info.hostname || terminal.name}</strong><br /><br /></td>
						</tr>
						<tr>
							<td class="pe-3">Anydesk ID</td>
							<td><strong>${terminal.anydesk_id}</strong></td>
						</tr>
					</table>
				`,
				btn_ok: `<i class="fa fa-headset me-2"></i>Csatlakozás`,
				btn_cancel: `<i class="fa fa-running me-2"></i>Mégse`,
				btn_ok_class: 'warning',
				onclose: (confirmed) => {
					if (confirmed) {
						window.open(`anydesk:${terminal.anydesk_id}`, '_self')
					}
				}
			})
		}
	},

	async sign_in_to_cloud (db_name) {
		const token = await Anvil.exec('c_order/company_db/action_get_sign_in_token', db_name)
		if (token) {
			window.open(`https://ugyfel.c-store.eu/sys_login_1.html?CEGID=${db_name}&logintoken=${token}`, '_blank')
		}
	},

	open () {
		let sel = Anvil.models.components.Grid.find('#terminal_grid').selected_rows
		if (sel.length > 0) {
			Anvil.exec('c_order/terminal/modal_edit', sel[0])
		}
	},

	openSite (company_db_id, site_id) {
		Anvil.exec('c_order/site/modal_edit', company_db_id, site_id)
	},
})

$('#terminal_grid').on('dblclick', 'tbody tr', function () {
	Anvil.page.open()
})
</script>
